import React from 'react';

const IconDelete = () => {
	return <em className="fa-light fa-trash-can"></em>;
};

export default IconDelete;